export const TEAMS = [
  {
    id: "drindranath",
    name: "Dr. Indranath Prasad",
    profession: "Phaco & Glaucoma Surgeon",
    summary:
      "Chief Medical Director MBBS, MS Ophthalmology Fellowship in anterior segment",
    overview:
      "Dr. Indranath Prasad is a highly experienced and skilled Phaco and Glaucoma Surgeon with a strong reputation for excellence in the field of ophthalmology. With a career spanning over several years, he has dedicated himself to providing superior medical and surgical care in the treatment of cataracts, glaucoma, and various anterior segment disorders. Dr. Prasad completed his MBBS and MS in Ophthalmology, where he was recognized for his exceptional skills and knowledge in the field. Following this, he further specialized in the anterior segment of the eye, earning a prestigious Fellowship in Anterior Segment. This advanced training has enhanced his ability to perform complex cataract surgeries, manage glaucoma cases, and treat a wide array of anterior segment conditions. As the Chief Medical Director, Dr. Indranath Prasad leads with a focus on patient-centric care, emphasizing high standards of clinical practice, innovative surgical techniques, and a deep commitment to restoring and preserving vision. His expertise extends to the latest advancements in Phacoemulsification and Glaucoma surgeries, ensuring optimal outcomes for his patients. Throughout his career, Dr. Prasad has remained a highly respected figure in the ophthalmic community, recognized for his contributions to the field, and for offering compassionate care to individuals with complex eye health concerns. With his profound knowledge and dedication, Dr. Indranath Prasad continues to make a significant impact in the lives of his patients, providing exceptional eye care with a focus on advanced surgical solutions and improved vision outcomes.",
    img: "https://prasad-eye-hospital-public.s3.ap-south-1.amazonaws.com/images/doctors/doc.jpg",
    imgAlt: "drindranath",
    yoe: 15,
    expertise: [
      "Phacoemulsification",
      "Glaucoma Surgery",
      "Anterior Segment Surgery",
      "Cataract Surgery",
      "Management of Glaucoma",
      "Laser Surgery",
      "Complex Cataract Management",
      "Refractive Surgery",
    ],
    qualification: [
      {
        degree: "Fellowship in Anterior Segment",
        location: "Lahan, Nepal",
      },
      {
        degree: "Master of Surgery in Ophthalmology (MS)",
        location: "Karnataka",
      },
      {
        degree: "Bachelor of Medicine, Bachelor of Surgery (MBBS)",
        location: "Karnataka",
      },
    ],
    honours: {
      heading:
        "Awards, Recognition, and Publications in Cataract and Glaucoma Surgery",
      description:
        "Dr. Indranath Prasad has received numerous awards for his contributions to the field of Phacoemulsification and Glaucoma surgery. His work has been recognized both nationally and internationally, and he has published extensively in peer-reviewed journals in the field of ophthalmology.",
    },
  },

  {
    id: "drarchana",
    name: "Dr. Archana Kumari",
    profession: "Vitreo Retina Surgeon",
    summary: "MBBS, MS Ophthalmology Fellowship in Vitreo Retina",
    overview:
      "Dr Archana Kumari is a dynamic Phaco and Vitreo Retina surgeon with more than half a decade of experience in retinal diseases. She completed her MBBS from Medical College Kolkata, followed by MS in Ophthalmology from Kolkata where she was the best performer in her batch. She then pursued a long-term surgical fellowship in Vitreo Retinal diseases. Her training includes leading National and International eye hospitals such as Sankara Nethralaya (Kolkata), CBM sponsored Lahan and Biratnagar Eye Hospital, Aravind Eye Hospital (Coimbatore), and LVPEI (Hyderabad). She is known for her outstanding surgical and medical outcomes, having performed over 2000 retinal surgeries and restoring vision to more than 5000 eyes.",
    img: "https://prasad-eye-hospital-public.s3.ap-south-1.amazonaws.com/images/doctors/doc0.jpg",
    imgAlt: "drarchana",
    yoe: 14,
    expertise: [
      "Diabetic eye diseases",
      "Retinal detachment",
      "Post cataract surgery complications",
      "Macular hole",
      "Age related macular degeneration",
      "Retinal breaks and hole lasers",
      "Intravitreal injections",
      "Traumatic ocular damage",
      "Retinopathy of prematurity",
      "Uveitis",
    ],
    memberships: [
      "Vitreo Retina Society of India",
      "All India Ophthalmological Society",
      "Kolkata Academy of Ophthalmology",
      "Eastern India Zonal Ophthalmological Congress",
      "Delhi Ophthalmological Society",
      "Jharkhand Ophthalmological Society",
    ],
    qualification: [
      {
        degree: "Retinopathy of Prematurity (ROP) Training",
        location: "LV Prasad Eye Institute, Hyderabad",
      },
      {
        degree: "Alcon Vitreo Retina Surgical Training",
        location: "Aravind Eye Hospital, Coimbatore",
      },
      {
        degree: "Fellowship in Vitreo Retina Surgery",
        location: "EREC-P, Lahan",
      },
      {
        degree: "Vitreo Retina Training in PGship",
        location: "Sankara Nethralaya, Kolkata",
      },
      {
        degree: "Master of Surgery in Ophthalmology (MS)",
        location: "Kolkata",
      },
      {
        degree: "Bachelor of Medicine, Bachelor of Surgery (MBBS)",
        location: "Kolkata",
      },
    ],
    honours: {
      heading:
        "Awards, Recognition, and Publications in Retinal Diseases and Surgeries",
      description:
        "Dr Archana Kumari has received several awards and gold medals for her extraordinary presentations on retinal diseases and surgeries at National and International platforms. She has published extensively in reputed peer-reviewed National and International journals.",
    },
  },
];
